import styled from 'styled-components'
export const Wrapper = styled.div`
  .passive-toggle {
    color: #ccc;
    cursor: pointer;
  }
  .active-toggle {
    color: var(--second-color);
    cursor: pointer;
  }
  .dolar {
    font-size: 3px;
    background-color: red !important;
  }
`
